import React from 'react';
import { isProduction } from 'src/lib/constants';
import { CmsCtaAssetBanner } from './CmsCtaAssetBanner';
import { CmsCtaHeaderBanner } from './CmsCtaHeaderBanner';
import { CmsCtaAdornmentBanner } from './CmsCtaAdornmentBanner/CmsCtaAdornmentBanner';

export const CmsCtaSwitch = ({ fields, sys }) => {
  const appearance = fields?.appearance;
  switch (appearance) {
    case 'Asset variation':
      return <CmsCtaAssetBanner fields={fields} sys={sys} />;
    case 'Header variation':
      return <CmsCtaHeaderBanner fields={fields} sys={sys} />;
    case 'Adornment variation':
      return <CmsCtaAdornmentBanner fields={fields} sys={sys} />;
    default:
      if (!isProduction) {
        return <p>hmm something went wrong</p>;
      }
      return null;
  }
};
